module.exports = __webpack_public_path__ + "static/media/Descending.Active.8072981a.svg";